import { useQuery } from '@tanstack/react-query';
import { entityAuditQuery, IAuditEvent, IWork } from '@diana/core';
import { DataChangeDetails } from '../../../../../../components/Tabs/Activities/DataChangeDetails';

interface IDataChangeDetails {
  keyword: string | null;
  thing: IWork | null;
  audit: IAuditEvent;
}

export const ThingDataChangeDetails = (props: IDataChangeDetails) => {
  const { thing, audit, keyword } = props;

  const query = entityAuditQuery.getDataChange({
    entityId: thing?.id ?? '',
    eventName: audit.activity.eventName ?? 'edited',
    userId: audit.user.userId,
    sectionId: audit.activity.sectionId ?? '',
  });

  const { data, isLoading } = useQuery({
    queryKey: query.key,
    queryFn: query.fn,
  });

  return <DataChangeDetails keyword={keyword} data={data} isLoading={isLoading} />;
};
